import { Button, Modal } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { useAppStore } from '../../../store/store';

export default function SessionExpiredOverlay() {
  const { t } = useTranslation();

  const isOpen = useAppStore((s) => s.appEvents.sessionExpired.isOpen);
  const secondsLeft = useAppStore((s) => s.appEvents.sessionExpired.secondsLeft);
  const clearTimers = useAppStore((s) => s.appEvents.sessionExpired.clearTimers);
  const close = useAppStore((s) => s.appEvents.sessionExpired.close);

  const modalStyles = { mask: { backdropFilter: 'blur(5px)' } };

  return (
    <Modal
      open={isOpen}
      closable={false}
      mask={{ closable: false }}
      footer={
        <div className="flex justify-end gap-2">
          <Button
            type="text"
            onClick={() => {
              clearTimers();
              close();
              useAppStore.getState().events.emit.makeLogout();
            }}
          >
            {t('modal.sessionExpired.goToLoginNow')}
          </Button>
        </div>
      }
      centered
      width={400}
      zIndex={9999}
      data-testid="session-expired-modal"
      styles={modalStyles}
      className="bg-black/25! backdrop-blur-sm!"
    >
      <h2 className="text-red mb-2 text-lg font-semibold">{t('modal.sessionExpired.title')}</h2>
      <p className="text-blue-dark mb-2 text-sm">{t('modal.sessionExpired.description')}</p>
      <p className="text-gray-dark text-sm">
        <Trans>{t('modal.sessionExpired.redirectMessage', { seconds: secondsLeft })}</Trans>
      </p>
    </Modal>
  );
}
